import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { hide, show } from '../../actions/ActivityIndicatorAction';
// Action
import { showMessage } from '../../actions/FlashMessageActions';
import {
  forgetPassword,
  generatePassword,
} from '../../actions/ForgetPasswordAction';
// Component
import ForgetPassword from '../../components/auth/ForgetPassword';

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      forgetPassword,
      generatePassword,
      showMessage,
      show,
      hide,
    },
    dispatch
  );

const ForgetPasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgetPassword);

export default withRouter(ForgetPasswordContainer);
